import type { RouteObject } from 'react-router'

import {
  NEW_SOCIAL_TOPIC_SEGMENT,
  SOCIAL_TOPIC_SEGMENT,
  SOCIAL_TOPICS_SEGMENT,
} from 'features/coverage/features/social-topics/paths'
import { COVERAGE_URL } from 'features/coverage/paths'
import { lazyComponent } from 'routes/lazy-route'

const topicPage = (
  exportName:
    | 'NewSocialTopicPanelContainer'
    | 'SocialTopicPanelContainer'
    | 'SocialTopicPageContainer',
): RouteObject['lazy'] =>
  lazyComponent(
    () =>
      import('features/coverage/features/social-topics/features/topic-page/Container'),
    exportName,
  )

// `FeatureGuardLayout` reads the deepest match's handle, so every leaf carries it.
const handle = { featureKey: COVERAGE_URL }

/** Children of the Coverage route. */
export const socialTopicsRoutes: RouteObject[] = [
  {
    path: SOCIAL_TOPICS_SEGMENT,
    children: [
      {
        index: true,
        lazy: lazyComponent(
          () => import('features/coverage/features/social-topics/Container'),
          'SocialTopicsIndexRedirect',
        ),
        handle,
      },
      {
        // Pathless, so the Ask Yogi registration it holds follows the page
        // when `new` hands off to the saved topic's uuid.
        lazy: topicPage('SocialTopicPageContainer'),
        children: [
          {
            path: NEW_SOCIAL_TOPIC_SEGMENT,
            lazy: topicPage('NewSocialTopicPanelContainer'),
            handle,
          },
          {
            path: SOCIAL_TOPIC_SEGMENT,
            lazy: topicPage('SocialTopicPanelContainer'),
            handle,
          },
        ],
      },
    ],
  },
]
